<div class="bv-account-danger-zone">
  <div class="bv-account-danger-zone__header">
    <h2 class="bv-account-danger-zone__title">{{ "dangerZone" | i18n }}</h2>
    <span class="bv-account-danger-zone__icon" aria-hidden="true"></span>
  </div>
  <p class="bv-account-danger-zone__desc">{{ "dangerZoneDesc" | i18n }}</p>
  <div class="bv-account-danger-zone__actions">
    <ng-content></ng-content>
  </div>
</div>
